import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import { getApi } from 'views/services/api';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useState } from 'react';
import moment from 'moment';
import { useEffect } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router';
import { constant } from 'views/constant';
import { patchApi } from 'views/services/api';
import axios from 'axios';
import TableStyle from 'ui-component/TableStyle';
import { Card } from '@mui/material';
import ShowBill from 'views/Reservation/Components/ShowBills';
import { DataGrid } from '@mui/x-data-grid'; 
import {Stack,Container} from '@mui/material';


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'left',
  color: theme.palette.text.secondary
}));

export default function CustomerBookingHistory() {
  const navigate = useNavigate();
  const [tabOption, setTabOption] = useState('1');
  const [billData, setbillData] = useState([]);
  const [totalFoodAmount, setTotalFoodAmount] = useState(0);
  const [reservationData, setReservationData] = useState([]);
  const params = useParams();
  const reservationId = params.id;

  const hotel = JSON.parse(localStorage.getItem('hotelData'));
  console.log("hotel data ====>",hotel);

  const fetechReservationData = async () => {
    try {
      console.log('api hit =>', `api/reservation/view/${reservationId}`);
      const response = await getApi(`api/reservation/view/${reservationId}`);
      console.log('here is the response =>', response);
      setReservationData(response.data.reservationData[0]);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSingleBillData = async () => {
    try {
      const response = await getApi(`api/singleinvoice/view/${reservationId}`);
      response.data.InvoiceData && setbillData((prevBillData) => [...(prevBillData || []), ...response.data.InvoiceData]);
    } catch (error) {
      console.log(error);
    }
  };

  // function for fetching all the contacts data from the db

  const fetchbillData = async () => {
    try {
      const response = await getApi(`api/invoice/view/${reservationId}`);
      setbillData(response?.data?.InvoiceData);
      console.log("data ==>",response);
      
    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    fetechReservationData();
    fetchbillData();
    fetchSingleBillData();
  }, []);

  const handleGenerateBill = (billItem) => {
    // console.log(billItem, 'billItem')
    if (billItem.type === "room" ||billItem.type === "food"  ) {
      navigate(`/roombill/view/${billItem._id}`);
    } else {
      navigate(`/singlebill/view/${billItem.reservationId}`);
    }
  };

  const calculateTotalFoodAmount = () => {
    if (!reservationData || !reservationData.foodItems) {
      return 0;
    }

    const totalFoodAmount = reservationData.foodItems.reduce((total, foodData) => {
      return total + foodData.quantity * foodData.price;
    }, 0);
    console.log('totalFoodAmount =>', totalFoodAmount);

    return totalFoodAmount;
  };

  useEffect(() => {
    setTotalFoodAmount(calculateTotalFoodAmount());
  }, [reservationData]);



  const columns = [
    {
      field: `invoiceNumber`,
      headerName: 'Invoice Number',
      flex: 1.5,
      cellClassName: 'name-column--cell name-column--cell--capitalize',
      renderCell: (params) => {
        return (
          <Box>
            <Box onClick={() => handleGenerateBill(params?.row)}>{params.value}</Box>
          </Box>
        );
      }
    },
    {
      field: `name`,
      headerName: 'Name',
      flex: 1,
      cellClassName: ' name-column--cell--capitalize',

      renderCell: (params) => {
        return (
          <Box>
            <Box>{params.value}</Box>
            <div style={{ marginTop: '4px', fontSize: '12px', color: '#777' }}>{params.row.customerPhoneNumber}</div>
          </Box>
        );
      }
    },
    {
      field: 'address',
      headerName: 'Address',
      flex: 1
    },

    {
      field: 'type',
      headerName: 'Invoice Type',
      flex: 1,
      renderCell: (params) => {
        return <Box>{params.row.type ? params.value : 'Food+Room'}</Box>;
      }
    },
    {
      field: 'foodAmount',
      headerName: 'Food Amount',
      flex: 1,
      renderCell: (params) => {
        return (
          <Box>
            {params.row.totalFoodAmount
              ? `${hotel?.currencyCode} ${params.row.totalFoodAmount}`
              : params.row.foodAmount
              ? `${hotel?.currencyCode} ${params.row.foodAmount}`
              : 'N/A'}
          </Box>
        );
      }
    },
    {
      field: 'roomRent',
      headerName: 'Room Amount',
      flex: 1,
      renderCell: (params) => {
        return (
          <Box>
            {params.row.totalRoomAmount ? `${hotel?.currencyCode} ${params.row.totalRoomAmount}` : params.row.roomRent ? ` ${params.row.roomRent}` : 'N/A'}
          </Box>
        );
      }
    },
    {
      field: 'advanceAmount',
      headerName: 'Advance Amount',
      flex: 1,
      renderCell: (params) => {
        return (
          <Box>
            {params.row.totalRoomAmount
              ? 'N/A'
              : params.row.advanceAmount
              ? `${hotel?.currencyCode} ${params.row.advanceAmount}`
              : params.row.totalRoomAmount
              ? 'N/A'
              : 'N/A'}
          </Box>
        );
      }
    },
    {
      field: 'discount',
      headerName: 'Discount',
      flex: 1,
      renderCell: (params) => {
        return <Box>{params.value ? `${hotel?.currencyCode} ${params.value}` : ' N/A'}</Box>;
      }
    },
    {
      field: 'totalAmount',
      headerName: 'Total Amount',
      flex: 1,
      renderCell: (params) => {
        return <Box>{params.row.totalAmount ? `${hotel?.currencyCode} ${params.row.totalAmount}` : `${hotel?.currencyCode} ${params.row.totalFoodAndRoomAmount}`}</Box>;
      }
    }
  ];

  return (
    <>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              sx={{ marginRight: 4, marginBottom: 1, color: '#673ab7', borderColor: '#673ab7' }}
              onClick={() => navigate(-1)}
            >
              Back
            </Button>
          </div>
        </Box>
        <Box sx={{ flexGrow: 1, overflowX: 'auto' }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              {/* Room Information */}
              <Item>
                <Typography variant="h4" fontWeight="bold">
                  Room Information
                </Typography>
                <hr />
                <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
                  <Grid item xs={6} md={6}>
                    <Typography variant="h5">Room Number :</Typography>
                    <Typography style={{ color: 'black' }}>{reservationData?.roomNo ? reservationData?.roomNo : 'N/A'}</Typography>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Typography variant="h5">Room Rent :</Typography>
                    <Typography style={{ color: 'black' }}>
                      {hotel?.currencyCode} {reservationData?.totalPayment ? reservationData?.totalPayment : 'N/A'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Typography variant="h5">Advance Amount :</Typography>
                    <Typography style={{ color: 'black' }}>
                    {hotel?.currencyCode} {reservationData?.advanceAmount ? reservationData?.advanceAmount : 'N/A'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Typography variant="h5">Remaining Amount:</Typography>
                    <Typography style={{ color: 'black' }}>
                    {hotel?.currencyCode} {reservationData?.totalAmount ? reservationData?.totalAmount : 'N/A'}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
                  <Grid item xs={6} md={6}>
                    <Typography variant="h5">Check-In :</Typography>
                    <Typography style={{ color: 'black' }}>
                      {reservationData?.checkInDate ? moment(reservationData?.checkInDate).format('YYYY-MM-DD') : 'N/A'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Typography variant="h5">Check-Out:</Typography>
                    <Typography style={{ color: 'black' }}>
                      {reservationData?.checkOutDate ? moment(reservationData?.checkOutDate).format('YYYY-MM-DD') : 'N/A'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Typography variant="h5">Total Days :</Typography>
                    <Typography style={{ color: 'black' }}>
                      {reservationData?.totalDays ? reservationData?.totalDays : 'N/A'} days
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Typography variant="h5">Total Restaurant Expense :</Typography>
                    <Typography style={{ color: 'black' }}>{hotel?.currencyCode} {totalFoodAmount ? totalFoodAmount : 'N/A'}</Typography>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Typography variant="h5">Total Amount ( Room + Restaurant ) :</Typography>
                    <Typography style={{ color: 'black' }}>
                    {hotel?.currencyCode}{' '}
                      {reservationData?.totalPayment && totalFoodAmount
                        ? reservationData?.totalPayment + totalFoodAmount
                        : reservationData?.totalPayment}
                    </Typography>
                  </Grid>
                </Grid>
              </Item>
            </Grid>

            {/* //customer Information______________________________________ */}
            <Grid item xs={12} md={6}>
              <Item sx={{ height: '100%' }}>
                <Typography variant="h4" fontWeight="bold">
                  Customer Information
                </Typography>
                <hr />
                <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
                  <Grid item xs={6} md={5}>
                    <Typography variant="h5">Name :</Typography>
                    <Typography style={{ color: 'black' }}>{reservationData?.fullName ? reservationData?.fullName : 'N/A'}</Typography>
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="h5"> Email:</Typography>
                    <Typography style={{ color: 'black' }}>
                      {reservationData?.customerDetails?.email ? reservationData?.customerDetails?.email : 'N/A'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="h5"> Phone Number:</Typography>
                    <Typography style={{ color: 'black' }}>
                      {reservationData?.customerDetails?.phoneNumber ? reservationData?.customerDetails?.phoneNumber : 'N/A'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="h5">Addresss:</Typography>
                    <Typography style={{ color: 'black' }}>
                      {reservationData?.customerDetails?.address ? reservationData?.customerDetails?.address : 'N/A'}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
                  <Grid item xs={6} md={5}>
                    <Typography variant="h5">{reservationData?.customerDetails?.idCardType} Number:</Typography>
                    <Typography style={{ color: 'black' }}>
                      {reservationData?.customerDetails?.idcardNumber ? reservationData?.customerDetails?.idcardNumber : 'N/A'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Typography variant="h5">ID Proof:</Typography>
                    <Typography style={{ color: 'black', marginTop: '7px' }}>
                      <a href={reservationData?.idFile} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                        <Button startIcon={<VisibilityIcon />} variant="contained" color="primary">
                          View ID Proof
                        </Button>
                      </a>
                    </Typography>
                  </Grid>
                </Grid>
              </Item>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/* <Grid container>
        <ShowBill />
      </Grid> */}
       <Container>
        <Stack direction="row" alignItems="center" mb={5} justifyContent={'space-between'}>
          <Stack direction="row" alignItems="center" justifyContent={'flex-end'} spacing={2}></Stack>
        </Stack>
        <TableStyle>
          <Box width="100%">
            <Card style={{ height: '600px', paddingTop: '15px' }}>
              <Typography variant="h4" sx={{ margin: '2px 15px' }}>
                Invoices ( {billData?.length || 0} )
              </Typography>
              {billData && (
                <>
                  <DataGrid
                    rows={billData}
                    columns={columns}
                    // checkboxSelection
                    getRowId={(row) => row?._id}
                    // slots={{ toolbar: GridToolbar }}
                    // slotProps={{ toolbar: { showQuickFilter: true } }}
                  />
                </>
              )}
            </Card>
          </Box>
        </TableStyle>
      </Container>
    </>
  );
}
